


























































import { defineComponent, computed, ref, useContext, PropType } from '@nuxtjs/composition-api'
import { useProductStore } from '@/store/product'

import IconFa6SolidAngleLeft from '~icons/fa6-solid/angle-left'
import IconFa6SolidAngleRight from '~icons/fa6-solid/angle-right'
import RelatedCarouselCard from '~/components/feature/PDP/RelatedCarouselCard.vue'
import RelatedCarouselModal from '~/components/feature/PDP/RelatedCarouselModal.vue'

import { buildRelatedProduct } from '@/composables/product/useBuildRelatedProduct'
import { ApplicationChiclets, Figure } from '~/types/product/productTypes'

export interface RelatedProduct {
  name: string
  productId: string
  productUrl: string
  productType: string
  imageUrl: string
  imagesData: Figure[]
  price: string | undefined
  size: string | undefined
  modalTitleData: {
    key: string
    name: string
    isProductDiscontinued: boolean
  }
  tableData?: Array<{ label: string; value: string | undefined }>
  applicationChiclets: ApplicationChiclets
}

export default defineComponent({
  components: {
    RelatedCarouselCard,
    RelatedCarouselModal,
    IconFa6SolidAngleLeft,
    IconFa6SolidAngleRight,
  },
  props: {
    recommendedProducts: {
      type: Array as PropType<string[]>,
      required: false,
      default: () => [],
    },
  },
  setup({ recommendedProducts }) {
    const { $config } = useContext()
    const productStore = useProductStore()

    const slickOptions = {
      arrows: false,
      slidesToShow: 3,
      lazyLoad: 'ondemand',
      infinite: false,
      responsive: [
        {
          breakpoint: 399,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    }

    const isModalLoading = ref(false)
    const modalData = ref({} as RelatedProduct)
    const modalProductIndex = ref(0)

    const onCardImageHover = (src: any) => {
      imageHoverUrl.value = src
    }

    const imageHoverUrl = ref()
    const onCardImageLeave = () => {
      imageHoverUrl.value = null
    }

    const isMultipleImages = computed(() => {
      return recommendedProducts.length > 3
    })

    const currentImage = ref(1)
    const onAfterChange = (_: number, newSlideIndex: number) => {
      currentImage.value = newSlideIndex + 1
    }

    const relatedProductCarousel = ref()
    const onArrowClick = (whereTo: string) => {
      if (whereTo === 'next') {
        relatedProductCarousel.value.next()
      } else {
        relatedProductCarousel.value.prev()
      }
    }

    const onButtonClick = async (direction: 'next' | 'previous', productIndex: number) => {
      const toBuildProductIndex = direction === 'next' ? productIndex + 1 : productIndex - 1
      if (recommendedProducts) {
        await buildModal(recommendedProducts[toBuildProductIndex], toBuildProductIndex)
      }
    }

    const buildModal = async (data: any, index: number) => {
      isModalLoading.value = true
      modalProductIndex.value = index
      modalData.value = buildRelatedProduct({
        product: data,
        config: $config,
      })
      await getCitationCount(data.id)
      isModalLoading.value = false
    }

    const isArrowDisabled = (position: 'previous' | 'next') => {
      if (position === 'previous') {
        return currentImage.value === 1
      }
      return currentImage.value + slickOptions.slidesToShow > recommendedProducts.length
    }

    const modalCitationCount = ref(0)
    const getCitationCount = async (productId: string) => {
      modalCitationCount.value = await productStore.fetchProductCitationCount(productId)
    }

    return {
      buildModal,
      onButtonClick,
      onArrowClick,
      slickOptions,
      onAfterChange,
      imageHoverUrl,
      modalCitationCount,
      isMultipleImages,
      onCardImageHover,
      onCardImageLeave,
      relatedProductCarousel,
      isArrowDisabled,
      isModalLoading,
      modalData,
      modalProductIndex,
    }
  },
})
